import {
    UPDATE_DEALER_CREDENTIALS, UPDATE_DEALER_CREDENTIALS_SUCCESSFUL, UPDATE_DEALER_CREDENTIALS_FAILED, RESET_ALERT,
    BULK_UPDATE_DEALER_CREDENTIALS, BULK_UPDATE_DEALER_CREDENTIALS_SUCCESSFUL, BULK_UPDATE_DEALER_CREDENTIALS_FAILED, PAGE_NUMBER, RESET_PAGE_NUMBER,
} from "./actionTypes"

export const updateDealerCredentials = (data) => {
    return {
        type: UPDATE_DEALER_CREDENTIALS,
        payload: { data }
    }
}

export const updateDealerCredentialsSuccessful = (message) => {
    return {
        type: UPDATE_DEALER_CREDENTIALS_SUCCESSFUL,
        payload: { message }
    }
}

export const updateDealerCredentialsFailed = (error) => {
    return {
        type: UPDATE_DEALER_CREDENTIALS_FAILED,
        payload: error
    }
}

export const bulkUpdateDealerCredentials = (data) => {
    return {
        type: BULK_UPDATE_DEALER_CREDENTIALS,
        payload: { data }
    }
}

export const bulkUpdateDealerCredentialsSuccessful = (message) => {
    return {
        type: BULK_UPDATE_DEALER_CREDENTIALS_SUCCESSFUL,
        payload: { message }
    }
}

export const bulkUpdateDealerCredentialsFailed = (error) => {
    return {
        type: BULK_UPDATE_DEALER_CREDENTIALS_FAILED,
        payload: error
    }
}

export const resetAlert = () => {
    return {
        type: RESET_ALERT,
    }
}
export const pageNumber = (value) => {
    return {
        type: PAGE_NUMBER,
        payload: value,
    };
};

